import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import * as T from './actionTypes';
import { fetchAssetTCOSuccess, fetchAssetTCOFail } from './actions';

const errMsg = (e, fallback) => e?.response?.data?.message || fallback;

function* fetchAssetTCOSaga({ payload: assetId }) {
  try {
    const { data } = yield call(api.get, `asset-tco?assetId=${assetId}`);
    yield put(fetchAssetTCOSuccess(data.response));
  } catch (error) {
    yield put(fetchAssetTCOFail(errMsg(error, 'Failed to load asset TCO')));
  }
}

export default function* assetTCOSaga() {
  yield takeLatest(T.FETCH_ASSET_TCO, fetchAssetTCOSaga);
}
